import { useEffect } from "react";
import Certifications from "@/components/Certifications";
import Contact from "@/components/Contact";

const CertificatesPage = () => {
  useEffect(() => {
    document.title = "Certifications - AI & Digital Marketing Expertise | BrandBorn";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "BrandBorn's verified certifications in AI Fundamentals (Google/Coursera), Digital Marketing (Great Learning), and Artificial Intelligence Mastery (Beep Learning). Trusted expertise for e-commerce onboarding.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16" data-testid="certificates-page">
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            Our <span className="text-red-500">Certifications</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Verified expertise in AI, Digital Marketing & E-commerce — recognized by Google, Coursera, and leading institutions.
          </p>
        </div>
      </section>
      <Certifications />
      <Contact />
    </div>
  );
};

export default CertificatesPage;
